var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{staticClass:"mr-2",attrs:{"value":_vm.toggle,"labels":{checked: 'Admin Emails', unchecked: 'No Admin Emails'},"width":120},on:{"change":function($event){return _vm.adminEmails($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }